import "./App.css";

import {
	LoginSocialFacebook,
	LoginSocialGoogle,
	LoginSocialGithub,
	LoginSocialAmazon,
	LoginSocialLinkedin,
	LoginSocialInstagram,
	LoginSocialMicrosoft,
	LoginSocialTwitter,
	LoginSocialPinterest,
	LoginSocialApple,
	LoginSocialTiktok,
} from "reactjs-social-login";

import {
	FacebookLoginButton,
	GoogleLoginButton,
	GithubLoginButton,
	AmazonLoginButton,
	InstagramLoginButton,
	LinkedInLoginButton,
	MicrosoftLoginButton,
	TwitterLoginButton,
	AppleLoginButton,
} from "react-social-login-buttons";

import { ReactComponent as PinterestLogo } from "./assets/pinterest.svg";
import { ReactComponent as TiktokLogo } from "./assets/tiktok.svg";
import { useCallback, useState } from "react";
import { User } from "./User";

const REDIRECT_URI = "https://react-social-login.netlify.app/account/login";

export default function App() {
	const [provider, setProvider] = useState("");
	const [profile, setProfile] = useState();

	const onLoginStart = useCallback(() => {
		alert("login start");
	}, []);

	const onLogoutSuccess = useCallback(() => {
		setProfile(null);
		setProvider("");
		alert("logout success");
	}, []);

	return (
		<>
			{provider && profile ? (
				<User
					provider={provider}
					profile={profile}
					onLogout={onLogoutSuccess}
				/>
			) : (
				<div className={`App ${provider && profile ? "hide" : ""}`}>
					<h1 className="title">ReactJS Social Login</h1>
					<LoginSocialFacebook
						appId={"2086263614924092"}
						onLoginStart={onLoginStart}
						fieldsProfile={
							"id,first_name,last_name,middle_name,name,name_format,picture,short_name,email"
						}
						redirect_uri={REDIRECT_URI}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<FacebookLoginButton />
					</LoginSocialFacebook>

					<LoginSocialGoogle
						client_id={
							"142305466831-ovd5bctacape4n6o1gjv9amrg73j84l8.apps.googleusercontent.com"
						}
						onLoginStart={onLoginStart}
						redirect_uri={REDIRECT_URI}
						typeResponse="idToken"
						scope="openid profile email"
						ux_mode="popup"
						onResolve={({ provider, data }) => {
							console.log("🚀 ~ file: App.js:89 ~ App ~ data:", data);
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<GoogleLoginButton />
					</LoginSocialGoogle>

					<LoginSocialApple
						client_id={"netlify.app.react-social-login"}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<div className="apple-btn">
							<AppleLoginButton />
						</div>
					</LoginSocialApple>

					<LoginSocialAmazon
						client_id={
							"amzn1.application-oa2-client.3e7d2da7589d4bfb85dad099ed80a28e"
						}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<AmazonLoginButton />
					</LoginSocialAmazon>

					<LoginSocialInstagram
						client_id={"1024858944679033"}
						client_secret="ac6793cb58a36f1a18d99b629f1408a6"
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						scope="user_profile,user_media,public_profile,instagram_basic pages_show_list,instagram_manage_insights,instagram_manage_comments manage_pages,ads_management,business_management,instagram_content_publish,page_read_engagement"
						onReject={(err) => {
							console.log(err);
						}}
					>
						<InstagramLoginButton />
					</LoginSocialInstagram>

					<LoginSocialMicrosoft
						client_id={"da630e6a-2932-475d-bf34-c33b8a05c03e"}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<MicrosoftLoginButton />
					</LoginSocialMicrosoft>

					<LoginSocialLinkedin
						client_id={"863h4lfylai4p4"}
						client_secret="tk8941wp1Udr8AtJ"
						scope="r_emailaddress,r_liteprofile,w_member_social"
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<LinkedInLoginButton />
					</LoginSocialLinkedin>

					<LoginSocialGithub
						client_id={"5f9ab708b9ba70b2150a"}
						client_secret="8819aaf24161614a7218bf3a0b2d41c9d602f3bc"
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<GithubLoginButton />
					</LoginSocialGithub>

					<LoginSocialPinterest
						client_id={"1472264"}
						client_secret={"a014e8802960e3f86101610033c1aece1d590e01"}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
						className="pinterest-btn"
					>
						<div className="content">
							<div className="icon">
								<PinterestLogo />
							</div>
							<span className="txt">Login With Pinterest</span>
						</div>
					</LoginSocialPinterest>

					<LoginSocialTwitter
						client_id={"LUlmQkFMWlZrNVNpVkNDU1oweEc6MTpjaQ"}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
					>
						<TwitterLoginButton />
					</LoginSocialTwitter>

					<LoginSocialTiktok
						client_key={"awht2bethyi2evyw"}
						redirect_uri={REDIRECT_URI}
						onLoginStart={onLoginStart}
						onResolve={({ provider, data }) => {
							setProvider(provider);
							setProfile(data);
						}}
						onReject={(err) => {
							console.log(err);
						}}
						className="pinterest-btn"
					>
						<div className="content">
							<div className="icon">
								<TiktokLogo />
							</div>
							<span className="txt">Login With Tiktok</span>
						</div>
					</LoginSocialTiktok>
				</div>
			)}
		</>
	);
}
